import Paper from "@mui/material/Paper";
import React from "react";
import {Tag, TagCategory} from "../../gen/api";
import Cluster from "./Cluster";
import Group from "./Group";
import {SxProps} from "@mui/material";
import Grid from "@mui/material/Grid";
import ClusterSelect from "./ClusterSelect";
import ClusterTreeSelect from "./ClusterTreeSelect";

type Props = {
  tagCategories: TagCategory[]
  handleOnClick: (tagId: string) => void
  handleToggleSubtree?: (tag: Tag, checked: boolean) => void
  selectedFilters: string[]
  sx?: SxProps
}

/**
 * This component is responsible for displaying tags.
 */
export default function TagTable({tagCategories, handleOnClick, handleToggleSubtree, selectedFilters, sx}: Props) {
  const onClick = (event: React.ChangeEvent<HTMLInputElement>) => handleOnClick(event.target.value)
  const onToggleSubtree = (tag: Tag, checked: boolean) => handleToggleSubtree?.(tag, checked)

  return (
      <Paper sx={{...sx, p: 2}}>
        <Grid container spacing={2}>
          {tagCategories.map(cluster => cluster.tags.length !== 0 &&
            <Cluster cluster={cluster} key={cluster.id}>
              <ClusterTreeSelect
                cluster={cluster}
                key={cluster.id}
                selectedTags={selectedFilters}
                onClick={onClick}
                onToggleSubtree={onToggleSubtree} />
            </Cluster>
            // <ClusterSelect
            //   cluster={cluster}
            //   key={cluster.id}
            //   selectedTags={selectedFilters}
            //   onClick={onClick} />
              // <Cluster cluster={cluster} key={cluster.id}>
              //   {cluster.tags?.map(group =>
              //       <Group group={group} selectedTags={selectedFilters} key={group.id}
              //              onClick={onClick}/>
              //   )}
              // </Cluster>
          )}

        </Grid>
      </Paper>
  );
}